<template>
    <v-app>
        <div class="md-layout">
            <div class="md-layout-item">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-green">
                        <div class="card-icon">
                            <md-icon>person_add</md-icon>
                        </div>
                        <h4 class="title">动态模板管理</h4>
                        <div style="text-align: right">
                            <md-button class="md-success md-sm addButton" @click="ToNewFormWork">新 增</md-button>
                            <!-- <md-button class="md-primary md-sm" @click.prevent.stop="guide()">开启引导</md-button> -->
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <v-data-table :headers="headers" :items="userListData.rows"
                            :sort-by="['currentSort', 'currentSortOrder']" :items-per-page="5"
                            :sort-desc="[false, true]" multi-sort hide-default-footer
                            class="paginated-table table-striped table-hover">
                            <template #[`item.template_type`]="{ item }">
                                <span>{{ typeList[item.template_type] }}</span>
                            </template>
                            <template v-slot:item.created_at="{ item }">{{ dateFormat(item.created_at) }}</template>
                            <template v-slot:top>
                                <v-row justify="space-between">
                                    <v-col class="d-flex" cols="6" sm="2">
                                        <v-select v-model="pagination.perPage" :items="pagination.perPageOptions"
                                            label="每页显示"></v-select>
                                    </v-col>
                                    <v-col class="d-flex" cols="6" sm="2">
                                        <v-text-field v-model="userListMap.name" label="查找" type="search" class="mb-3"
                                            clearable style="width: 200px"></v-text-field>
                                    </v-col>
                                </v-row>
                            </template>
                            <template v-slot:item.option="{ item }">
                                <div>
                                    <md-button class="md-just-icon md-success md-round md-simple" style="padding-right: 30px;"
                                        @click.native="handleEdit(item)">
                                        <md-icon>edit</md-icon>
                                    </md-button>

                                    <md-button class="md-just-icon md-danger md-round md-simple"
                                        @click.native="handleDelete(item)">
                                        <md-icon>close</md-icon>
                                    </md-button>
                                </div>

                            </template>
                        </v-data-table>
                    </md-card-content>
                    <md-card-actions md-alignment="space-between">
                        <div class="">
                            <p class="card-category">
                                {{ from + 1 }} 到 {{ to }} ，共 {{ userListData.total }}
                            </p>
                        </div>
                        <pagination class="pagination-no-border pagination-success" v-model="userListMap.page"
                            :per-page="userListMap.pageSize" :total="userListData.total">
                        </pagination>
                    </md-card-actions>
                </md-card>
            </div>
        </div>
    </v-app>
</template>
<script>
    import { Pagination } from "@/components";
    import users from "../Tables/users";
    import Fuse from "fuse.js";
    import moment from "moment";
    import Swal from "sweetalert2";
    import { userRecover, userList, addAction, listAction, removeRole } from '@/api/user';

    export default {
        components: {
            Pagination,
        },
        computed: {
            /***
             * Returns a page from the searched data or the whole data. Search is performed in the watch section below
             */
            queriedData () {
                let result = this.tableData;
                if (this.searchedData.length > 0) {
                    result = this.searchedData;
                }
                return result.slice(this.from, this.to);
            },
            to () {
                let highBound = this.from + this.pagination.perPage;
                if (this.total < highBound) {
                    highBound = this.total;
                }
                return highBound;
            },
            from () {
                return this.pagination.perPage * (this.pagination.currentPage - 1);
            },
            total () {
                return this.searchedData.length > 0 ?
                    this.searchedData.length :
                    this.tableData.length;
            },
        },
        data () {
            return {
                loading: false,
                userListData: {
                    count: 0,
                    totle_page: 0,
                    userList: []
                },
                typeList: {
                    scene: '场景',
                    role: '角色',
                    tool: '工具',
                    device: '设备',
                },
                headers: [{
                    text: '模板名称',
                    align: 'center',
                    value: 'name',
                    filterable: true
                },
                { text: '类型', align: 'center', value: 'template_type' },
                {
                    text: '创建时间',
                    value: 'created_at',
                    align: 'center'
                },
                { text: '编辑', align: 'center', value: 'option', width: "100px" }
                ],
                userListMap: {
                    page: 1,
                    pageSize: 5,
                    perPageOptions: [5, 10, 25, 50],
                    name: ''
                },
                currentSort: "name",
                currentSortOrder: "asc",
                pagination: {
                    perPage: 5,
                    currentPage: 1,
                    perPageOptions: [5, 10, 25, 50],
                    total: 0,
                },
                searchQuery: "",
                searchQueryTime: '',
                propsToSearch: ["account", "email", "mobile", "name", "company"],
                tableData: users,
                searchedData: [],
                fuseSearch: null,
                timer: null
            };
        },
        watch: {
            ['userListMap.pageSize'] () {
                this.userListMap.page = 1;
                this.userList();
            },
            ['userListMap.name'] () {
              
                this.userList();
            },
          
            ['userListMap.page'] () {
                this.userList();
            },
            searchQuery () {
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    this.userListMap.name = this.searchQuery;
                    this.userListMap.page = 1;
                    this.userList();
                }, 500);
            }
        },
        created () {
            this.userList();
        },
        methods: {
            ToNewFormWork () {
                this.$router.push({ path: './newFormWork', })
            },
            dateFormat (date) {
                return moment(date).format("YYYY-MM-DD HH:mm:ss");
            },
            userList () {
                this.loading = true;
                listAction(this.userListMap).then((res) => {
                    if (res.code === '200') {
                        this.userListData = res.data;
                        this.loading = false;
                    }
                }).catch(() => {
                    this.loading = false;
                });
            },
            customSort (value) {
                return value.sort((a, b) => {
                    const sortBy = this.currentSort;
                    if (this.currentSortOrder === "desc") {
                        return a[sortBy].localeCompare(b[sortBy]);
                    }
                    return b[sortBy].localeCompare(a[sortBy]);
                });
            },
            handleEdit (item) {

                this.$router.push({ name: 'NewFormWork', query:  item });
            },


            async handleDelete (item) {
                let result = await Swal.fire({
                    title: "删除信息",
                    text: `${item.name} 记录被删除后将无法恢复，请确认！`,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "md-button md-success btn-fill",
                    cancelButtonClass: "md-button md-danger btn-fill",
                    confirmButtonText: "确 定",
                    cancelButtonText: "取 消",
                    buttonsStyling: false,
                });

                if (result.value) {
                    const delResult = await removeRole(item);
                    if (delResult.code == 200) {
                        Swal.fire({
                            title: "已删除!",
                            text: `您已经删除 ${item.name}`,
                            type: "success",
                            confirmButtonClass: "md-button md-success btn-fill",
                            buttonsStyling: false,
                        });
                        this.getList();
                    }
                }
            },




            handleRecover (item) {
                Swal.fire({
                    title: "恢复信息",
                    text: `请确认恢复用户信息！`,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "md-button md-success btn-fill",
                    cancelButtonClass: "md-button md-danger btn-fill",
                    confirmButtonText: "确 定",
                    cancelButtonText: "取 消",
                    buttonsStyling: false,
                }).then((result) => {
                    if (result.value) {
                        this.userRecover(item.uid);
                    }
                });
            },
            userRecover (uid) {
                let that = this;
                let tempData = {
                    uid: uid
                }
                userRecover(tempData).then((res) => {
                    if (res.code === '200') {
                        this.userList();
                        this.$message.success('恢复成功');
                    }
                })
            },

            deleteRow (item) {
                let indexToDelete = this.tableData.findIndex(
                    (tableRow) => tableRow.id === item.id
                );
                if (indexToDelete >= 0) {
                    this.tableData.splice(indexToDelete, 1);
                }
            },
        },
        mounted () {
            // Fuse search initialization.
            this.fuseSearch = new Fuse(this.tableData, {
                keys: ["name", "email"],
                threshold: 0.3,
            });
        }
    };
</script>
<style lang="css" scoped>
    .md-card .md-card-actions {
        border: 0;
        margin-left: 20px;
        margin-right: 20px;
    }
</style>